<template>
  <section :class="`image-copy-block ${(data.reverse_layout ? 'reverse' : '')} ${(data.theme ? `has-theme ${data.theme}` : '')} ${data.image ? '' : 'no-image'}`">

    <div v-if="data.image" class="image">
      <img :src="data.image.url" :alt="data.image.alt" />
    </div>

    <div class="copy">
      <span v-if="data.label" class="label">{{data.label}}</span>
      <h2 v-if="data.title">{{data.title}}</h2>
      <div class="wysiwyg" v-html="data.copy"></div>
      <a v-if="data.link" :href="data.link.url" class="btn large" :target="data.link.target">{{data.link.title}}</a>
    </div>
  </section>
</template>

<script>
export default {
  props: ['data'],
};
</script>

<style scoped lang="less">
@import '../css/variables';

.image-copy-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 40px 0;
  padding: 40px 0;
  &.theme-1 {
    background-color: @themeColor1;
  }
  &.theme-2 {
    background-color: @themeColor2;
    .copy {
      color: @themeColor1;
    }
  }
  &.reverse {
    flex-direction: row-reverse;
  }
  &.has-theme {
    padding: 80px;
    @media (max-width: @mobile) {
      padding: 30px;
    }
  }
  @media (max-width: @mobile) {
    display: block;
  }
  &.no-image {
    .copy {
      width: 100%;
    }
  }

  .label {
    display: inline-block;
    margin-bottom: 30px;
    padding: 8px 10px 6px 10px;
    font-size: 14px;
    text-transform: uppercase;
    color: #fff;
    background-color: @themeColor3;
    border-radius: 5px;
  }

  .image {
    width: 48%;
    @media (max-width: @mobile) {
      width: 100%;
      margin-bottom: 20px;
    }
    img {
      max-width: 100%;
    }
  }

  .copy {
    width: 48%;
    @media (max-width: @mobile) {
      width: 100%;
    }
    h2 {
      margin-bottom: 20px;
    }
  }
}
</style>

<style lang="less">
.image-copy-block .wysiwyg {
  p,
  ul {
    font-size: 20px;
    line-height: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ImageCopyBlock.vue